import { CalendarClock, MapPinHouse, Toolbox, Users } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const Manage: React.FC = () => {
  return (
    <div className="p-2">
      <div className="grid grid-cols-12 gap-2">
        <Link
          to={"/manage/slots"}
          className="border px-6 py-4 col-span-12 sm:col-span-3 flex flex-col justify-center items-center bg-gray-100 shadow-sm border-gray-200 rounded-md"
        >
          <div className="mb-2">
            <CalendarClock size={40} className="text-gray-900" />
          </div>
          <div className="">

            SLOTS
          </div>
        </Link>
        <Link
          to={"/manage/sites"}
          className="border px-6 py-4 col-span-12 sm:col-span-3 flex flex-col justify-center items-center bg-gray-100 shadow-sm border-gray-200 rounded-md"
        >
          <div className="mb-2">
            <MapPinHouse size={40} className="text-gray-900" />
          </div>
          <div className="">

            BRANCHES
          </div>
        </Link>
        <Link
          to={"/manage/services"}
          className="border px-6 py-4 col-span-12 sm:col-span-3 flex flex-col justify-center items-center bg-gray-100 shadow-sm border-gray-200 rounded-md"
        >
          <div className="mb-2">
            <Toolbox size={40} className="text-gray-900" />
          </div>
          <div className="">

            SERVICES
          </div>
        </Link>
        <Link
          to={"/manage/users"}
          className="border px-6 py-4 col-span-12 sm:col-span-3 flex flex-col justify-center items-center bg-gray-100 shadow-sm border-gray-200 rounded-md"
        >
          <div className="mb-2">
            <Users size={40} className="text-gray-900" />
          </div>
          <div className="">

            USERS
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Manage;
